import { Box, Button, Typography } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import Reveal from '../commons/Reveal';
import AnimatedTitle from '../commons/AnimatedTitle';
import { getWhatsappLink } from '../commons/homeData';
import {
  bodyFont, ctaSx, eyebrowSx, homeColors, sectionContentSx,
} from '../style/homeStyles';

const Contacto = ({ isMobile }) => {
  const whatsappLink = getWhatsappLink();

  return (
    <Box
      component="section"
      sx={{
        backgroundColor: homeColors.white,
        padding: isMobile ? '64px 20px' : '80px 24px',
        textAlign: 'center',
      }}
    >
      <Box sx={sectionContentSx}>
        <Reveal>
          <Box sx={{ display: 'flex', marginBottom: '14px' }}>
            <Typography component="span" sx={eyebrowSx}>
              {i18n.homeContactEyebrow}
            </Typography>
          </Box>
          <AnimatedTitle
            text={i18n.homeContactTitle}
            fontSize={isMobile ? 24 : 40}
            sx={{ lineHeight: 1.3, textAlign: 'left' }}
          />
          {/* Mobile: botón ancho y centrado. Desktop: alineado a la izquierda, como el título. */}
          <Box sx={{
            marginTop: '28px',
            display: 'flex',
            justifyContent: isMobile ? 'center' : 'flex-start',
          }}
          >
            <Button
              component="a"
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              endIcon={<WhatsAppIcon />}
              sx={{
                ...ctaSx,
                fontFamily: bodyFont,
                width: isMobile ? '90%' : 'auto',
                minWidth: isMobile ? 0 : 240,
                // El Button de MUI le gana en especificidad a un sx puesto en el ícono.
                '& .MuiButton-endIcon > *:nth-of-type(1)': { fontSize: 22 },
              }}
            >
              {i18n.homeContactCta}
            </Button>
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
};

Contacto.propTypes = {
  isMobile: PropTypes.bool,
};

Contacto.defaultProps = {
  isMobile: false,
};

export default Contacto;
